// extracted by mini-css-extract-plugin
module.exports = {"radio":"InputRadio_radio__3vBTB","input":"InputRadio_input__3wm2U","inner":"InputRadio_inner__2A6Qf","tick":"InputRadio_tick__3buRA","text":"InputRadio_text__3R-Ub"};